import React from 'react';

type Props = {
  attribute?: string[] | null;
};

export const LinkAttribute: React.FC<Props> = ({ attribute }) => {
  return (
    <>
      {attribute?.map((value, i) => (
        <div data-id="linkAttr" key={i}>
          <a href={value} target="_blank" rel="noreferrer">
            {value}
          </a>
        </div>
      ))}
    </>
  );
};
